export default "__VITE_ASSET__BMrA0LLJ__"